import { createApp } from "vue";
import ActivityTopAuthors from "./ActivityTopAuthors.vue";
import RepoActionView from "./RepoActionView.vue";

export function initRepoActivityTopAuthorsChart() {
  const el = document.querySelector("#repo-activity-top-authors-chart");
  if (el) {
    createApp(ActivityTopAuthors).mount(el);
  }
}

export function initRepoActionView() {
  const el = document.getElementById("repo-action-view");
  if (!el) return;

  const view = createApp(RepoActionView, {
    runIndex: el.getAttribute("data-run-index"),
    jobIndex: el.getAttribute("data-job-index"),
    actionsURL: el.getAttribute("data-actions-url"),
  });
  view.mount(el);
}
